import { Link } from 'react-router-dom';
import type { ShowItem } from '@/mocks/shows';
import ShowCard from './ShowCard';

interface Props {
  items: ShowItem[];
}

export default function PopularSection({ items }: Props) {
  return (
    <section className="mx-auto max-w-[1440px] px-4 md:px-8 py-12 md:py-16">
      <div className="flex items-end justify-between mb-6 md:mb-8">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950">热门影视推荐</h2>
          <p className="mt-1 text-sm text-foreground-500 font-body">本周热度最高的电视剧与电影作品</p>
        </div>
        <Link to="/category/tv" className="hidden sm:flex items-center gap-1 text-sm text-primary-600 font-label font-medium cursor-pointer whitespace-nowrap">
          查看更多
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
        {items.map((item) => (
          <ShowCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}